import React from 'react';
import Icon from '../AppIcon';

const LiveIndicator = ({ isLive, lastUpdate, className = '' }) => {
  const formatTime = (date) => {
    if (!date) return '';
    return new Intl.DateTimeFormat('es-MX', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })?.format(date);
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center gap-1.5">
        <div
          className={`w-2 h-2 rounded-full transition-all duration-300 ${
            isLive
              ? 'bg-green-500 animate-pulse shadow-lg shadow-green-500/50'
              : 'bg-gray-400'
          }`}
        />
        <span className="text-xs font-medium text-muted-foreground">
          {isLive ? 'Actualizando...' : 'En vivo'}
        </span>
      </div>
      {lastUpdate && (
        <div className="flex items-center gap-1 text-xs text-muted-foreground">
          <Icon name="Clock" className="w-3 h-3" />
          <span>{formatTime(lastUpdate)}</span>
        </div>
      )}
    </div>
  );
};

export default LiveIndicator;